import GlobalStyles from 'assets/styles/GlobalStyles';
import Layout from 'components/layout';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from 'sections/FarmingPage/PageHeader';
import Footer from 'sections/Footer/v1';
import Header from 'sections/Header/v1';
import SaleSubmission from 'sections/SaleSubmissionPage';

const SaleSubmisson = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Layout>
        <GlobalStyles />
        <Header />
        <PageHeader
          currentPage={t('saleSubmission.pageTitle')}
          pageTitle={t('saleSubmission.pageTitle')}
        />
        <SaleSubmission />
        {/* <Footer /> */}
      </Layout>
    </Fragment>
  );
};

export default SaleSubmisson;
